import OrganizationStorage, {
  getKnowledgeBaseDisplayFilename,
  getKnowledgeBaseFileKind,
  filterKnowledgeBasePreviewKeys,
  createLocalFilePreviewUrl,
} from '@/mixins/Organization/OrganizationStorage.js'
import { getKnowledgeBaseFileKindFromName } from '@/utils/knowledgeBaseFiles.js'
import { normalizeKnowledgeBaseFiles } from '@/mixins/Organization/UploadKnowledgeBase.js'

function getLocalFileKind(file) {
  return getKnowledgeBaseFileKindFromName(file?.name) || getKnowledgeBaseFileKind(file?.name)
}

export default {
  mixins: [OrganizationStorage],
  data() {
    return {
      selectedFileId: null,
      selectedPreview: null,
      selectedPreviewRequestId: 0,
    }
  },
  beforeUnmount() {
    this.revokeSelectedPreviewUrl()
  },
  methods: {
    buildExistingFileEntries(s3Keys, orgId) {
      return filterKnowledgeBasePreviewKeys(s3Keys).map((key) => ({
        id: `existing-${key}`,
        label: getKnowledgeBaseDisplayFilename(key, orgId),
        kind: getKnowledgeBaseFileKind(key),
        source: 'existing',
        key,
      }))
    },
    buildLocalFileEntries(files) {
      return normalizeKnowledgeBaseFiles(files).map((file, index) => ({
        id: `local-${index}-${file.name}`,
        label: file.name,
        kind: getLocalFileKind(file),
        source: 'local',
        file,
        index,
      }))
    },
    revokeSelectedPreviewUrl() {
      if (this.selectedPreview?.url?.startsWith('blob:')) {
        URL.revokeObjectURL(this.selectedPreview.url)
      }
    },
    closePreview() {
      this.revokeSelectedPreviewUrl()
      this.selectedFileId = null
      this.selectedPreview = null
      this.selectedPreviewRequestId += 1
    },
    openPreviewExternally() {
      const url = this.selectedPreview?.url
      if (!url) return
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    async selectFileEntry(entry) {
      if (this.selectedFileId === entry.id && !this.selectedPreview?.loading) {
        const hasContent =
          this.selectedPreview?.url ||
          (this.selectedPreview?.text != null && this.selectedPreview.text !== '')
        if (hasContent) {
          this.closePreview()
          return
        }
      }

      this.selectedFileId = entry.id
      await this.loadSelectedPreview(entry)
    },
    async loadSelectedPreview(entry) {
      const requestId = ++this.selectedPreviewRequestId
      this.revokeSelectedPreviewUrl()

      this.selectedPreview = {
        id: entry.id,
        label: entry.label,
        kind: entry.kind,
        source: entry.source,
        url: '',
        text: null,
        loading: true,
      }

      try {
        let url = ''
        let text = null

        if (entry.source === 'local') {
          if (entry.kind === 'pdf') {
            url = await createLocalFilePreviewUrl(entry.file, entry.kind)
          } else if (entry.kind === 'text') {
            text = await entry.file.text()
          }
        } else if (entry.kind === 'pdf') {
          url = (await this.getS3ObjectUrl(entry.key, 'pdf')) || ''
        } else if (entry.kind === 'text') {
          text = (await this.getS3TextContent(entry.key)) ?? ''
        }

        if (requestId !== this.selectedPreviewRequestId) return

        this.selectedPreview = {
          id: entry.id,
          label: entry.label,
          kind: entry.kind,
          source: entry.source,
          url,
          text,
          loading: false,
        }
      } catch (error) {
        console.log('Err', error)
        if (requestId !== this.selectedPreviewRequestId) return

        this.selectedPreview = {
          id: entry.id,
          label: entry.label,
          kind: entry.kind,
          source: entry.source,
          url: '',
          text: null,
          loading: false,
        }
      }
    },
    autoSelectFirstFileEntry(entries) {
      if (!entries.length) return

      const first = entries[0]
      const hasPreview =
        this.selectedPreview &&
        !this.selectedPreview.loading &&
        (this.selectedPreview.url || this.selectedPreview.text != null)

      if (this.selectedFileId === first.id && hasPreview) return

      if (!this.selectedFileId || this.selectedFileId !== first.id || !hasPreview) {
        this.selectFileEntry(first)
      }
    },
  },
}
